var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "locationComponent", staticClass: "fx-location-component" },
    [
      _c("div", { staticClass: "selection", on: { click: _vm.openMenu } }, [
        _vm.selectedLocation
          ? _c(
              "span",
              { staticClass: "selection-value" },
              [
                _vm._t(
                  "location",
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.selectedLocation.city) +
                        ", " +
                        _vm._s(_vm.selectedLocation.subdivision) +
                        ", " +
                        _vm._s(_vm.selectedLocation.country_code) +
                        "\n            "
                    )
                  ],
                  { location: _vm.selectedLocation }
                )
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.selectedLocation
          ? _c("span", { staticClass: "selection-placeholder" }, [
              _vm._v("\n            " + _vm._s(_vm.placeholder) + "\n        ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.selectedLocation,
                expression: "!selectedLocation"
              }
            ],
            staticClass: "open-menu-icon"
          },
          [_vm._t("caret", [_c("span", { staticClass: "icon-caret-down" })])],
          2
        )
      ]),
      _vm._v(" "),
      _c("span", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.selectedLocation,
            expression: "selectedLocation"
          }
        ],
        staticClass: "cancel-selection icon-cancel",
        on: {
          click: function($event) {
            _vm.select(null)
          }
        }
      }),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isMenuOpen,
            expression: "isMenuOpen"
          }
        ],
        staticClass: "location-overlay",
        on: { click: _vm.closeMenu }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isMenuOpen,
              expression: "isMenuOpen"
            }
          ],
          staticClass: "location-menu"
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.query,
                expression: "query"
              }
            ],
            ref: "locationInput",
            staticClass: "location-input",
            attrs: {
              type: "text",
              placeholder: _vm.placeholder,
              "aria-label": "Location"
            },
            domProps: { value: _vm.query },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.query = $event.target.value
                },
                _vm.onInput
              ],
              keyup: [
                function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "down", 40, $event.key, [
                      "Down",
                      "ArrowDown"
                    ])
                  ) {
                    return null
                  }
                  return _vm.onArrowDown($event)
                },
                function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "up", 38, $event.key, [
                      "Up",
                      "ArrowUp"
                    ])
                  ) {
                    return null
                  }
                  return _vm.onArrowUp($event)
                },
                function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.onEnter($event)
                },
                function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")
                  ) {
                    return null
                  }
                  return _vm.closeMenu($event)
                }
              ]
            }
          }),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "fx-list location-options" },
            [
              _vm.currentLocation
                ? _c(
                    "li",
                    {
                      staticClass: "current-location-option",
                      class: {
                        highlighted: _vm.highlightedSuggestionIndex == 0
                      },
                      on: {
                        click: function($event) {
                          _vm.select(_vm.currentLocation, true)
                          _vm.closeMenu()
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "crosshair-icon" }),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.currentLocationLabel) +
                          "\n            "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.locations, function(location, index) {
                return _c(
                  "li",
                  {
                    class: {
                      highlighted:
                        _vm.highlightedSuggestionIndex ==
                        (_vm.currentLocation ? index + 1 : index)
                    },
                    on: {
                      click: function($event) {
                        _vm.select(location)
                        _vm.closeMenu()
                      }
                    }
                  },
                  [
                    _vm._t(
                      "location",
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(location.city) +
                            ", " +
                            _vm._s(location.subdivision) +
                            ", " +
                            _vm._s(location.country_code) +
                            "\n                "
                        )
                      ],
                      { location: location }
                    )
                  ],
                  2
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("span", {
            staticClass: "close-menu icon-close",
            on: { click: _vm.closeMenu }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }